import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  TDistributorType,
  TDistributorTypeForm,
} from "../types/distributorTypes.types";
import distributorTypeApi from "../services/distributorType.api";
import { useIsAuth } from "../../../utils/useAuth";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  DISTRIBUTOR_TYPE_MESSAGES_ERROR,
  DISTRIBUTOR_TYPE_MESSAGES_SUCCESS,
} from "../constants/messages";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";

export const useSaveDistributorTypeMutation = () => {
  const queryClient = useQueryClient();
  const { userData } = useIsAuth();

  return useMutation<ApiResponse<TDistributorType>, Error, TDistributorTypeForm>(
    {
      mutationFn: async (distributorType) => {
        const payload: TDistributorTypeForm = {
          ...distributorType,
          updatedBy:
            distributorType._id && userData?.userId
              ? userData.userId
              : undefined,
        };
        return distributorTypeApi.saveDistributorType(payload);
      },
      onSuccess: (res) => {
        if (!res.ok) {
          errorNotification(DISTRIBUTOR_TYPE_MESSAGES_ERROR.SAVE_ERROR);
          return;
        }
        successNotification(DISTRIBUTOR_TYPE_MESSAGES_SUCCESS.SAVE_SUCCESS);
        queryClient.invalidateQueries({ queryKey: ["distributor-types"] });
      },
      onError: () => {
        errorNotification(DISTRIBUTOR_TYPE_MESSAGES_ERROR.SAVE_ERROR);
      },
    },
  );
};
